import '../utils/complianceChecker/index.js'
import { checkCompliance, manageCookiesTrigger } from '../utils/complianceChecker/utils.js'

// Freshdesk's chat widget sets its own cookies for session/conversation
// state. This OneTrust setup has no dedicated "Functional" category
// (only C0001 Necessary, C0002 Performance, C0004 Targeting), so it's
// gated behind Performance as the closest fit.
const REQUIRED_GROUPS = ['C0002']

const loadFreshdeskWidget = (config) => {
    const initFreshdesk = () => {
        window.fdWidget.init({
            host: config.host,
            token: config.token,
            widgetId: config.widgetId,
        })
    }

    if (document.getElementById('Freshdesk-js-sdk')) {
        initFreshdesk()
        return
    }

    const script = document.createElement('script')
    script.id = 'Freshdesk-js-sdk'
    script.async = true
    script.src = `${config.host}/webchat/js/widget.js`
    script.onload = initFreshdesk
    document.head.appendChild(script)
}

const chatbotInit = () => {
    const config = window.freshdeskConfig
    if (!config) return

    const fallback = document.querySelector('.js-chatbot-fallback')

    // Always wired, regardless of compliance - once the fallback is hidden
    // (widget loaded) this listener is simply never triggered again.
    if (fallback) manageCookiesTrigger(fallback)

    let loaded = false

    window.addEventListener('complianceCheck', (e) => {
        const activeGroups = e.detail?.activeGroups || []
        const isCompliant = checkCompliance(activeGroups, REQUIRED_GROUPS)

        if (fallback) fallback.hidden = isCompliant

        if (loaded || !isCompliant) return

        loaded = true
        loadFreshdeskWidget(config)
    })
}
chatbotInit()